'use strict';

import menu from './menu';

const sections = {
  fixedClass: 'is-fixed',
  sections: document.querySelectorAll('.content-section'),
  docTitle: document.getElementById('document-title'),
  cover: document.getElementById('cover'),
  scroller() {
    // console.log('========================= ' + Date.now() + ' =========================')

    const docTitleLimit = this.cover.clientHeight - this.cover.getBoundingClientRect().bottom;
    if (!this.docTitle.classList.contains(this.fixedClass) && docTitleLimit > 300) this.docTitle.classList.add(this.fixedClass);
    if (this.docTitle.classList.contains(this.fixedClass) && docTitleLimit < 300) this.docTitle.classList.remove(this.fixedClass);

    for(let index = 0; index < this.sections.length; index++) {
      const top = this.sections[index].getBoundingClientRect().top - menu.getShape().height - this.docTitle.clientHeight;
      const bottom = this.sections[index].getBoundingClientRect().bottom - menu.getShape().height - this.docTitle.clientHeight;

      if (!this.sections[index].classList.contains(this.fixedClass) && top < 0) {
        this.sections[index].classList.add(this.fixedClass);
        this.sections[index].firstChild.style.top = menu.getShape().height + this.docTitle.clientHeight + 'px';
      }

      // if ((this.sections[index].classList.contains(this.fixedClass) && bottom < 0) || (top > 0 && bottom > 0)) this.sections[index].classList.remove(this.fixedClass);
      if (top > 0 && bottom > 0) {
        this.sections[index].classList.remove(this.fixedClass);
        this.sections[index].firstChild.style.top = 0;
      }

      // console.groupCollapsed(this.sections[index].id);
      // console.log(this.sections[index]);
      // console.dir(this.sections[index]);
      // console.log('Bounding Top: ', top);
      // console.log('Bounding Bottom: ', bottom);
      // console.groupEnd();
    }

    // console.log('=================================================================')
  },
  scrollHandler() {
    return this.scroller.bind(this)();
  }
};

export default sections;
